import {
  TAG_TYPE_NAME,
  TagTypeTagV2,
  UserTagsV2Payload,
  UserTagsV2Response,
} from "@/types/tagsV2";
import { apiV2 } from "../apiV2/apiV2";

export const sendProviderName = async (
  payload: UserTagsV2Payload
): Promise<UserTagsV2Response> => {
  const response = await apiV2.tags.post(payload);

  return response.data;
};

export const getProviderTags = async (): Promise<TagTypeTagV2[]> => {
  const response = await apiV2.tags.getByTagType(TAG_TYPE_NAME.PROVIDER);

  return response.data;
};
